export default "__VITE_ASSET__954e793d__"